import React from 'react';
import { Create } from 'react-admin';

import VendorForm from './VendorForm';
import ErrorBoundary from '../ErrorBoundary';

const VendorCreate = props => (
    <ErrorBoundary>
        <Create {...props} title="New Supply Vendor">
            <VendorForm redirect="list" />
        </Create>
    </ErrorBoundary>
);

export default VendorCreate;
